import React from "react";
import styles from "./vision.module.css";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const VisionSection = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/project`);
  };

  

  return (
    <React.Fragment>
      <Container>
        <div className={styles.main_section}>
          <Row>
            <Col md={6}>
              <div className={styles.top_section}>
                <h6>Turning Vision into Reality</h6>
                <span>
                  Explore our success stories and impactful projects across
                  industries and regions.
                </span>
              </div>
            </Col>
            <Col md={6}>
              <div className={styles.section}>
                <p>
                  At <strong>CrossBorder BTC,</strong> we pride ourselves on
                  delivering results that matter. From groundbreaking solar
                  energy projects to innovative water supply systems, our
                  projects exemplify our commitment to excellence,
                  sustainability, and innovation.
                </p>
              </div>
            </Col>
          </Row>
        </div>

        <div className={styles.container}>
          <div className={styles.left}>
            <img
              onClick={handleClick}
              loading="lazy"
              src="/images/landingPageImages/hut.png"
              alt="hut"
            />
          </div>
          <div className={styles.right}>
            <img
              onClick={handleClick}
              loading="lazy"
              src="/images/landingPageImages/hawamahal.png"
              alt="hawamahal"
            />
            <img
              onClick={handleClick}
              loading="lazy"
              src="/images/landingPageImages/energy.png"
              alt="solor"
            />
          </div>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default VisionSection;
